<template>
    <div class="ottux-widget">
        <slot></slot>
    </div>
</template>
<script>
export default {
  name: 'OttWidget',
}
</script>
<style scoped lang="scss">
  @import "../scss/ottux-widget.scss";
</style>